import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7f3dce20")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", { class: "title" }, /*#__PURE__*/_toDisplayString('Briskly'), -1)
_popScopeId()

import { Icon } from '@brskl/ui-lib';

export default _defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Icon), {
      name: "dot",
      class: "icon"
    }),
    _hoisted_2
  ]))
}
}

})